import React from "react";
import { TbPencil, TbTrash } from "react-icons/tb";
import { Box, Button, Col, Dialog, FabButton, Flex, Row, SelectField, Typography, } from "../../../ppui";
import { getDayName } from "../../../utils/common";
import { logger } from "../../../utils/logger";
import { AllowanceBox, ContentHeading } from "../../style";
import useOrgWeeklyOffService from "./use-org-weekly-off-service";

const OrganizationWeeklyOff = () => {
  const {
    handleChange,
    handleSubmit,
    orgWeeklyOffInputs,
    errors,
    orgWeeklyOffData,
    orgWeeklyOffModal,
    handleClickOrgWeeklyOffModalClose,
    handleClickOpenEditModal,
    handleClickOpenAddModal,
    orgWeeklyOffDeleteModal,
    handleClickCloseDeleteModal,
    handleClickDeletebtn,
    handleDelete,
    createFormUpdateLoading
  } = useOrgWeeklyOffService();
  logger.log("orgWeeklyOffData", orgWeeklyOffData)
  return (
    <>
      <Box>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Weekly Off
          </Typography>
          <Button
            color="primary"
            variant="outlined"
            size="sm"
            onClick={handleClickOpenAddModal}
          >
            Add New
          </Button>
        </ContentHeading>

        <Flex gap={20} direction={"column"}>
          {orgWeeklyOffData.length > 0 ? orgWeeklyOffData.map((item, index) => {
            return (
              <AllowanceBox key={index}>
                <Row alignItems="center">
                  <Col>
                    <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }}>
                      <Col md={3} xl={2}>
                        <Box className="label">Days</Box>
                        <Box className="value">
                          {getDayName(item?.days)}
                        </Box>
                      </Col>
                      <Col md={3} xl={2}>
                        <Box className="label">Repeat</Box>
                        <Box className="value">
                          {item?.repeat ?
                            {
                              'every_week': 'Every Week',
                              'only_first_week': 'Only First Week',
                              'only_second_week': 'Only Second Week',
                              'only_third_week': 'Only Third Week',
                              'only_forth_week': 'Only Forth Week',
                              'only_fifth_week': 'Only Fifth Week',
                              'first_&_third_week': 'First & Third Week',
                              'second_&_forth_week': 'Second & Forth Week'
                            }[item.repeat] || 'N/A'
                            : 'N/A'}</Box>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={"auto"}>
                    <Flex justifyContent="end" gap="10">
                      <FabButton
                        size="sm"
                        icon={<TbTrash />}
                        onClick={() =>
                          handleClickDeletebtn(item)
                        }
                        variant="filled"
                        shape="box"
                      />
                      <FabButton
                        size="sm"
                        icon={<TbPencil />}
                        onClick={() => handleClickOpenEditModal(item)}
                        variant="filled"
                        shape="box"
                      />
                    </Flex>
                  </Col>
                </Row>
              </AllowanceBox>
            )
          }) :
            <Typography>
              No Org Weeklyoff Data
            </Typography>
          }
        </Flex>
        <Dialog
          title={orgWeeklyOffData?.weekly_holiday_id ? "Update Weekly Off" : "Add Weekly Off"}
          closeButton={true}
          fullWidth
          maxWidth="xs"
          open={orgWeeklyOffModal}
          onClose={handleClickOrgWeeklyOffModalClose}
          separator
          onSubmit={() => handleSubmit()}
          btnLoading={createFormUpdateLoading}
        >
          <Row rowGap>
            <Col sm={12} >
              <SelectField
                fullWidth
                required
                label="Days"
                options={[
                  { id: 1, name: "Sunday" },
                  { id: 2, name: "Monday" },
                  { id: 3, name: "Tuesday" },
                  { id: 4, name: "Wednesday" },
                  { id: 5, name: "Thursday" },
                  { id: 6, name: "Friday" },
                  { id: 7, name: "Saturday" },
                ]}
                placeholder="Select Here..."
                defaultValue={orgWeeklyOffInputs?.days}
                valueSinc={!!orgWeeklyOffInputs?.days}
                onChange={(val) => handleChange(val, 'days')}
                error={errors.days}
                helperText={errors?.days}
              />
            </Col>

            <Col sm={12} >
              <SelectField
                fullWidth
                required
                label="Repeat"
                options={[
                  { id: "every_week", name: "Every Week" },
                  { id: "only_first_week", name: "Only First Week" },
                  { id: "only_second_week", name: "Only Second Week" },
                  { id: "only_third_week", name: "Only Third Week" },
                  { id: "only_forth_week", name: "Only Forth Week" },
                  { id: "only_fifth_week", name: "Only Fifth Week" },
                  { id: "first_&_third_week", name: "First & Third Week" },
                  { id: "second_&_forth_week", name: "Second & Forth Week" },
                ]}
                placeholder="Select Here..."
                defaultValue={orgWeeklyOffInputs?.repeat}
                valueSinc={!!orgWeeklyOffInputs?.repeat}
                onChange={(val) => handleChange(val, 'repeat')}
                error={errors?.repeat}
                helperText={errors?.repeat}
              />
            </Col>
          </Row>
        </Dialog>
        <Dialog
        title={`Confirm Delete`}
        fullWidth
        maxWidth="xs"
        closeButton={true}
        open={orgWeeklyOffDeleteModal}
        onClose={handleClickCloseDeleteModal}
        onSubmit={handleDelete}
        btnLoading={createFormUpdateLoading}
        buttonName={"Delete"}
      >
        
        <Typography variant="body2" py={"20"}>Are you sure to delete Weekly Off details ?</Typography>
      </Dialog>
      </Box>
    </>
  );
};

export default OrganizationWeeklyOff;
